import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Constant } from "../../Constant";
import * as yup from "yup";
import Header from "../../component/Header/Header";
import { Box, Container, Grid } from "@material-ui/core";
import Navbar from "../../component/Navbar/Navbar";
import StepHeader from "../../component/StepHeader/StepHeader";
import { initialForm, setCurrentStep } from "../../redux/action";
import { getCurrentStep } from "../../redux/selector";
import TableInputSample from "./TableInputSample";
import Confirmation from "./Confirmation";

function TableInputSampleForm() {
    const { t, i18n } = useTranslation();

    const formId = "SampleForm";
    const stepNames = ["Table Input Sample", "Confirmation"];

    //init set up
    const dispatch = useDispatch();
    const currentStep = useSelector(getCurrentStep());
    useEffect(() => {
        dispatch(initialForm("SampleForm"));
        dispatch(setCurrentStep("TableInputSample"));
    }, []);

    const renderStep = (step) => {
        switch (step) {
            case "TableInputSample":
                return <TableInputSample />;
            case "Confirmation":
                return <Confirmation />;
            default:
                break;
        }
    };

    const getParentStep = (step) => {
        switch (step) {
            case "TableInputSample":
                return {
                    step: 0,
                    stepName: "Table Input Sample",
                };
            case "Confirmation":
                return {
                    step: 1,
                    stepName: "Confirmation",
                };
            default:
                break;
        }
    };

    return (
        <main>
            <Container>
                <Box className="wrapper personalInfo">
                    <Header formName={formId} />
                    <Box className="mainWrapper">
                        <Navbar
                            stepNames={stepNames}
                            step={getParentStep(currentStep)?.step}
                        />
                        <Box className="contentWrapper">
                            <StepHeader
                                title={getParentStep(currentStep)?.stepName}
                                step={getParentStep(currentStep)?.step}
                            />
                            {renderStep(currentStep)}
                        </Box>
                    </Box>
                </Box>
            </Container>
        </main>
    );
}

export default TableInputSampleForm;
